<mat-card class="trinta-card mb-25 bg-white border-none d-block text-center">
    <mat-card-content>
        <h3>Su usuario no tiene módulos asignados</h3>
        <p class="text-black fs-15">
            Para ver la Torre de Control o los módulos de Tarifas, solicite al administrador de OPB 360°
            que se los asigne. Los cambios se aplican al volver a iniciar sesión.
        </p>
        <a routerLink="/authentication/logout" mat-button>
            Cerrar sesión
            <i class="ri-logout-box-r-line"></i>
        </a>
    </mat-card-content>
</mat-card>
